import { render } from "./ElementItemGroup.vue?vue&type=template&id=39b31d6e"
import script from "./ElementItemGroup.vue?vue&type=script&lang=js"
export * from "./ElementItemGroup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__